import { render, staticRenderFns } from "./Statistika.vue?vue&type=template&id=fe3371ee&"
import script from "./Statistika.vue?vue&type=script&lang=js&"
export * from "./Statistika.vue?vue&type=script&lang=js&"
import style0 from "./Statistika.vue?vue&type=style&index=0&id=fe3371ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports